import { format, parseISO } from 'date-fns';

const SHORT_DAY_FORMAT = 'EEE, dd MMM';
const FULL_DAY_FORMAT = 'EEE, dd MMM yyyy';
const DAY_MONTH_FORMAT = 'dd MMM';

export const DATE_RANGE_SEPARATOR = ' – ';

export const formatShortDay = (isoDate: string): string =>
  format(parseISO(isoDate), SHORT_DAY_FORMAT);

export const formatFullDay = (isoDate: string): string =>
  format(parseISO(isoDate), FULL_DAY_FORMAT);

export function formatDayRange(firstDate: string, lastDate: string): string {
  if (firstDate === lastDate) return formatShortDay(firstDate);
  const firstLabel = format(parseISO(firstDate), DAY_MONTH_FORMAT);
  const lastLabel = format(parseISO(lastDate), DAY_MONTH_FORMAT);
  return `${firstLabel}${DATE_RANGE_SEPARATOR}${lastLabel}`;
}
